import type { Answers, FieldDef } from '../api/types'

/** Fields this person is asked: those switched on, and the under-18 ones only when they are under 18. */
export function visibleFields(fields: FieldDef[], minor: boolean): FieldDef[] {
  return fields.filter((f) => f.active && (!f.minorsOnly || minor))
}

/** Groups fields under their heading, in order; fields with no heading come first under an empty heading. */
export function groupFields(fields: FieldDef[]): { group: string; fields: FieldDef[] }[] {
  const out: { group: string; fields: FieldDef[] }[] = []
  for (const f of fields) {
    const g = f.group ?? ''
    const last = out.find((x) => x.group === g)
    if (last) last.fields.push(f)
    else out.push({ group: g, fields: [f] })
  }
  return out.sort((a, b) => (a.group === '' ? -1 : b.group === '' ? 1 : 0))
}

/** Turns the stored text answers into what the inputs edit (arrays for multi-choice, booleans for tick boxes). */
export function toAnswers(fields: FieldDef[], stored: Record<string, string>): Answers {
  const out: Answers = {}
  for (const f of fields) {
    const v = stored[f.key]
    if (v === undefined) continue
    if (f.type === 'MULTI_SELECT') {
      try {
        out[f.key] = JSON.parse(v) as string[]
      } catch {
        out[f.key] = []
      }
    } else if (f.type === 'CHECKBOX') out[f.key] = v === 'true'
    else out[f.key] = v
  }
  return out
}
